import React, { Component } from 'react';
import './Book.css';
import BookContent from './BookContent';
import Header from '../Header/Header';
import Toc from '../Toc/Toc';
import axios from 'axios';
import config from "../../config";
import {
  resetPageViewDedupe,
  setContext,
  trackPageViewIfChanged,
  trackTextbookBrowseOnce,
} from '../../utils/analytics';

class Book extends Component {
  constructor(props) {
    super(props)

    this.authorizationRequestId = 0;
    this.authorizeSettled = false;
    this.tocRequestId = 0;
    this.tocBookId = null;
    this.navigationRequestId = 0;
    this.locationReady = false;

    this.state = {
      drawerOpen: true,
      authors: '',
      title: '',
      toc: [],
      pdf_filename: '',
      prevSection: '',
      nextSection: '',
      currentChapterId: '',
      currentSectionId: '',
      currentSubSectionId: '',
      relativePageNumberHash: '',
      chapterPreviewable: false,
      hasPurchasedBookAccess: false
    }
  }

  verifyAccess(book_id = this.props.match.params.book_id) {
    const currentUser = this.props.currentUser;
    const requestId = ++this.authorizationRequestId;
    const isCurrent = () => requestId === this.authorizationRequestId &&
      currentUser === this.props.currentUser && book_id === this.props.match.params.book_id;

    setContext(null);
    this.authorizeSettled = false;
    this.setState({ hasPurchasedBookAccess: false });

    if (!this.props.authenticationSettled) { return; }

    if (currentUser) {
      return axios.get(config.api.DOMAIN + '/api/auth/authorize', {
        withCredentials: true,
        params: {
          'book_id': book_id
        }
      })
      .then(responseData => {
        if (!isCurrent()) { return; }
        setContext(responseData.data);
        this.setState({
          hasPurchasedBookAccess: responseData.data.has_access
        });
        this.authorizeSettled = true;
        this.props.onAnalyticsContextReady?.();
        this.tryEmitReaderAnalytics();
      })
      .catch(error => {
        if (!isCurrent()) { return; }
        setContext(null);
        console.error(error);
        this.authorizeSettled = true;
        this.props.onAnalyticsContextReady?.();
        this.tryEmitReaderAnalytics();
      });
    }

    this.authorizeSettled = true;
    this.tryEmitReaderAnalytics();
  }

  tryEmitReaderAnalytics() {
    if (!this.readerActive || !this.props.authenticationSettled || !this.authorizeSettled ||
        this.tocBookId !== this.props.match.params.book_id) { return; }

    trackTextbookBrowseOnce(this.tocBookId, this.state.title);
    if (this.locationReady) { trackPageViewIfChanged(); }
  }

  componentDidMount() {
    this.readerActive = true;
    resetPageViewDedupe();
    this.loadToc();
    this.verifyAccess();
  }

  loadToc() {
    const { book_id } = this.props.match.params;
    const requestId = ++this.tocRequestId;
    const isCurrent = () => this.readerActive && requestId === this.tocRequestId &&
      book_id === this.props.match.params.book_id;

    this.tocBookId = null;
    this.locationReady = false;
    this.navigationRequestId += 1;
    this.setState({ title: '', authors: '', toc: [], pdf_filename: '', chapterPreviewable: false });

    // get the toc for the book
    return fetch(`/tocs/${book_id}.json`)
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }

      return response.json();
    })
    .then(data => {
      if (!isCurrent()) { return; }
      this.setState({
        authors: data.authors,
        title: data.title,
        toc: data.toc
      }, () => {
        if (!isCurrent()) { return; }
        this.tocBookId = book_id;
        document.title = `${data.title} | FlatWorld Viewer`;
        this.setLocation();
        this.tryEmitReaderAnalytics();
      });
    })
    .catch(error => {
      if (!isCurrent()) { return; }
      console.log('Looks like there was a problem: \n', error);
    });
  }

  componentDidUpdate(prevProps) {
    const { book_id, chapter_id, section_id, element_id } = this.props.match.params;
    const bookChanged = book_id !== prevProps.match.params.book_id;
    const userChanged = prevProps.currentUser !== this.props.currentUser;

    if (bookChanged) {
      this.loadToc();
    }

    if (userChanged || bookChanged || prevProps.authenticationSettled !== this.props.authenticationSettled) {
      this.verifyAccess(book_id);
    }

    if (bookChanged) { return; }

    if (chapter_id !== prevProps.match.params.chapter_id || section_id !== prevProps.match.params.section_id || element_id !== prevProps.match.params.element_id ||
        this.props.location?.pathname !== prevProps.location?.pathname) {
      this.setLocation();
    } else if (this.props.location?.search !== prevProps.location?.search) {
      this.tryEmitReaderAnalytics();
    }
  }

  componentWillUnmount() {
    this.readerActive = false;
    this.authorizationRequestId += 1;
    this.tocRequestId += 1;
    setContext(null);
  }

  setLocation() {
    const { book_id, chapter_id, section_id, element_id } = this.props.match.params;
    const requestId = ++this.navigationRequestId;
    this.locationReady = false;
    if (this.tocBookId !== book_id) { return; }
    const chapters = this.state.toc;
    const book_path = "/books/" + book_id;
    let currentChapterId, currentSectionId, currentSubSectionId, currentInternalId;

    if(chapters.length > 0) {
      var prevSection, nextSection, currentPdfFilename, relativePageNumberHash, currentChapterPreviewable;
      
      if (chapter_id && chapter_id !== "read") {
        //scroll to location on toc
        window.location.hash = "#" + chapter_id;

        // get the chapter we are on
        const chapter = chapters.find(obj => {
          return obj.element_id === this.props.match.params.chapter_id
        });

        currentPdfFilename = chapter.pdf_filename;
        currentChapterPreviewable = chapter.previewable;

        currentChapterId = chapter.element_id;
        prevSection = chapter.previous_element != null ? book_path + chapter.previous_element : '';
        nextSection = chapter.next_element != null ? book_path + chapter.next_element : '';

        // Check if this is a section
        if (section_id && section_id !== "read") {
          // get the current section
          const section = chapter.sections.find(obj => {
            return obj.element_id === this.props.match.params.section_id
          });

          currentPdfFilename = section.pdf_filename;
          currentSectionId = section.element_id;
          prevSection = section.previous_element != null ? book_path + section.previous_element: '';
          nextSection = section.next_element != null ? book_path + section.next_element: '';

          if (element_id && element_id !== "read") {
            const subsection = section.sections.find(obj => {
              return obj.element_id === this.props.match.params.element_id
            });

            if (subsection.pdf_filename) {
              currentPdfFilename = subsection.pdf_filename;
              relativePageNumberHash = subsection.relative_page_number;
            }

            currentSubSectionId = subsection.element_id;
            currentInternalId = subsection.internal_id;
            prevSection = subsection.previous_element != null ? book_path + subsection.previous_element: '';
            nextSection = subsection.next_element != null ? book_path + subsection.next_element: '';
          }
        }
      } else {
        window.location = book_path + '/' + chapters[0].element_id + '/read';
        return;
      }

      this.setState({
        prevSection: prevSection,
        nextSection: nextSection,
        pdf_filename: currentPdfFilename,
        currentChapterId: currentChapterId,
        currentSectionId: currentSectionId,
        currentSubSectionId: currentSubSectionId,
        currentInternalId: currentInternalId,
        relativePageNumberHash: relativePageNumberHash,
        chapterPreviewable: currentChapterPreviewable
      }, () => {
        if (!this.readerActive || requestId !== this.navigationRequestId) { return; }
        this.locationReady = true;
        this.tryEmitReaderAnalytics();
      });
    }
  }

  isAuthorized(){
    return (this.getRolePrivileges() || this.state.chapterPreviewable || this.state.hasPurchasedBookAccess)
  }

  getRolePrivileges(){
    let userIsAdminOrEducator = false;
    const { currentUser } = this.props;

    if (currentUser) {
      const userRoles = currentUser.roles;
      if (userRoles && (userRoles.includes("internal") || userRoles.includes("educator"))) {
        userIsAdminOrEducator = true;
      }
    }

    return userIsAdminOrEducator;
  }

  toggleDrawer = () => {
    this.setState({ drawerOpen: !this.state.drawerOpen })
  };

  render() {
    const isAuthorized = this.isAuthorized();
    const { currentUser } = this.props;
    const { book_id } = this.props.match.params;
    const { 
      currentChapterId, 
      currentSectionId, 
      currentSubSectionId,
      currentInternalId,
      title, 
      toc, 
      pdf_filename,
      prevSection,
      nextSection,
      relativePageNumberHash,
      drawerOpen } = this.state;

    return (
      <div className="Book">

        <a href="#content" className="skip-main" tabIndex="-1">Skip to main content</a>

        <Header 
          currentUser={currentUser}
          drawerOpen={drawerOpen}
          title={title}
          toggleDrawer={this.toggleDrawer} />
        
        <Toc
          book_id={book_id}
          toc={toc}
          currentChapterId={currentChapterId}
          currentSectionId={currentSectionId}
          currentSubSectionId={currentSubSectionId}
          drawerOpen={drawerOpen}
          toggleDrawer={this.toggleDrawer} />

        <BookContent
          currentUser={currentUser}
          isAuthorized={isAuthorized}
          title={title}
          toc={toc}
          book_id={book_id}
          currentChapterId={currentChapterId}
          currentSectionId={currentSectionId}
          drawerOpen={drawerOpen}
          pdf_filename={pdf_filename}
          relativePageNumberHash={relativePageNumberHash}
          currentInternalId={currentInternalId}
          prevSection={prevSection}
          nextSection={nextSection}
          path={this.props.match.path}
          element_id={this.props.match.params.element_id} />
      </div>
    );
  }
}

export default Book;
